var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9902 11.5756C21.9071 9.61767 21.2506 7.7273 20.1021 6.13939C18.9536 4.55147 17.3638 3.33603 15.5304 2.64408C13.6969 1.95213 11.7005 1.81417 9.78924 2.24736C7.878 2.68055 6.13618 3.66578 4.78021 5.08063C3.42423 6.49548 2.51388 8.27758 2.16227 10.2055C1.81066 12.1334 2.03329 14.1221 2.8025 15.9246C3.57171 17.727 4.85359 19.2637 6.48886 20.3437C8.12412 21.4237 10.0407 21.9994 12.0004 21.9992C12.1497 21.9992 12.2973 21.9992 12.4448 21.9885",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9901 11.5756L12.4447 21.9885",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4349 21.9992V21.1299C12.4349 18.5931 13.4427 16.1602 15.2364 14.3665C17.0302 12.5727 19.4631 11.5649 21.9999 11.5649",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickers);
export default __webpack_public_path__ + "static/media/stickers.f20f93ff31bd9e36cad7375f5f443aa2.svg";
export { ForwardRef as ReactComponent };